<template>
    <b-dropdown
        class="no-padding"
        :class="{ 'is-expanded': expanded }"
        :position="position"
        @active-change="a => active = a">
        
        <div
            expanded
            class="button is-primary is-fullwidth"
            :class="{
                'is-outlined': !active
            }"
            slot="trigger">
            <span>
                {{ model | moment("D MMMM YYYY (dddd)") }}
            </span>
            <b-icon
                :icon="active ? 'menu-down' : 'menu-up'">
            </b-icon>
        </div>

        <b-dropdown-item custom paddingless>

            <calendar
                v-model="model"
                v-bind="$attrs"
                v-on="$listeners"
            />
        </b-dropdown-item>

    </b-dropdown>
</template>

<script>
export default Vue.extend({
  props: {
    value: Object,
    expanded: {
      type: Boolean
    },
    open: {
      type: Boolean,
      default: false
    },
    position: {
      type: String,
      default: "is-bottom-right"
    }
  },
  data() {
    return {
      model: this.value,
      active: this.open
    };
  },
  watch: {
    model(value) {
      this.$emit("input", value);
    }
  }
});
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/CalendarDropdown.vue